/* global window, toast, t */
// ============================================================
// MVA-termin — handlingene, ett sted
// ============================================================
// Innsendinger-siden og arbeidsflaten AI Regnskapsfører åpner over sin egen
// side viser den samme MVA-meldingen. Lå mutasjonene i siden, ville modalen
// fått sin egen kopi av innsending, tolldeklarasjon og oppgjør — og to steder
// å endre den dagen innsendingen faktisk går til Altinn.
//
// Funksjonene her gjør én ting hver, melder fra med toast og returnerer om det
// gikk. De vet ingenting om hvilken flate de kalles fra; flaten selv bestemmer
// hva som skal skje etterpå (`onChanged`, `onCloseDialog`).
const createVatTermActions = ({ onChanged, onCloseDialog } = {}) => {
  const changed = () => { if (onChanged) void onChanged(); };
  const closeDialog = () => { if (onCloseDialog) onCloseDialog(); };
  const backend = () => window.PlummeBackend || null;
  return {
    // Plumme cannot file the return. `nextSubmitted: true` marks the term as
    // filed outside Plumme (the user filed with Skatteetaten), `false` clears
    // that status. `filing` carries { filedDate, reference, comment }. The
    // value is explicit so a click can never toggle a status the user can't see.
    submitTerm: async (term, nextSubmitted, filing = {}) => {
      const filed = typeof nextSubmitted === 'boolean'
        ? nextSubmitted
        : !(term?.status === 'levert' || term?.status === 'levert-betalt');
      try {
        await backend()?.markVatTermFiledOutside?.({ year: term?.year, termKey: term?.key, filed, ...(filing || {}) });
        changed();
        return true;
      } catch (error) {
        toast(error?.message || t('vat.filing.failed'), 'error');
        return false;
      }
    },
    saveCustoms: async (entry) => {
      try {
        await backend()?.saveCustomsDeclaration?.(entry);
        closeDialog();
        changed();
        toast(t('vat.customsSaved', 'Tolldeklarasjon lagret'), 'success');
        return true;
      } catch (error) {
        toast(error?.message || t('vat.customsSaveFailed', 'Kunne ikke lagre tolldeklarasjonen.'), 'error');
        return false;
      }
    },
    annulCustoms: async (id) => {
      try {
        await backend()?.annulCustomsDeclaration?.(id);
        changed();
        toast(t('vat.customsAnnulled', 'Tolldeklarasjon annullert'), 'success');
        return true;
      } catch (error) {
        toast(error?.message || t('vat.customsAnnulFailed', 'Kunne ikke annullere tolldeklarasjonen.'), 'error');
        return false;
      }
    },
    savePayment: async (term, record) => {
      if (!term) return false;
      try {
        await backend()?.saveVatPaymentRecord?.({ year: term.year, termKey: term.key, record });
        closeDialog();
        changed();
        toast(record?.settlementKind === 'refund' ? t('vat.refundSaved', 'Tilbakebetaling lagret') : t('vat.paymentSaved', 'Betaling lagret'), 'success');
        return true;
      } catch (error) {
        toast(error?.message || t('vat.paymentSaveFailed', 'Kunne ikke lagre betalingen.'), 'error');
        return false;
      }
    },
    deletePayment: async (term, record) => {
      if (!term || !record?.id) return false;
      try {
        await backend()?.deleteVatPaymentRecord?.({ year: term.year, termKey: term.key, recordId: record.id });
        changed();
        toast(record.settlementKind === 'refund' ? t('vat.refundCancelled', 'Tilbakebetaling annullert') : t('vat.paymentCancelled', 'Betaling annullert'), 'success');
        return true;
      } catch (error) {
        toast(error?.message || t('vat.paymentCancelFailed', 'Kunne ikke annullere betalingen.'), 'error');
        return false;
      }
    },
  };
};

Object.assign(window, { createVatTermActions });
